import AuditLogPage from 'auditlog/AuditLogPage';
import AuditLogConfigurationPage from 'auditlog/AuditLogConfigurationPage';

export default {
  routes: [
    { path: '/system/auditlog', component: AuditLogPage },
    { path: '/system/auditlog/configuration', component: AuditLogConfigurationPage },
  ],
};
